import type { SxProps, Theme } from "@mui/material";

export const customerSelectSx = {
  "& .MuiOutlinedInput-root": { borderRadius: "16px" },
} satisfies SxProps<Theme>;
